import React, { useState } from 'react';
import { useDialogsContext } from '../../../contexts/Dialog';
import { useLinesContext } from '../../../contexts/Lines';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Dialog from '../../BuildingBlocks/Dialogs/DialogStyleOne/Dialog';
import Create from './Create';
import Success from './Success';
import Typography from '@material-ui/core/Typography';

const fontSize = '1.2em';

const useStyles = makeStyles((theme) => ({
  root: {
    textAlign: 'center',
    '& .MuiTypography-h3': { fontWeight: 'bold' },
    '& .MuiTypography-body1': { fontSize },
    '& .MuiButton-root': { fontSize, minWidth: 175 },
    '& .MuiDialog-paper': { maxWidth: 550, minHeight: 425 },
  },
  content: { padding: theme.spacing(3) },
  icon: {
    width: 125,
    marginBottom: theme.spacing(2),
    color: theme.palette.primary.main,
  },
}));

export default function AutoCreateLinesDialog({ lineToTemplate }) {
  const classes = useStyles();
  const dialog: any = useDialogsContext();
  const { createLineFromScratch, firstLineGeneration } = useLinesContext();
  const [success, setSuccess] = useState(false);
  const [numLinesCreated, setNumLinesCreated] = useState(0);

  function handleClose({ successClose = false }) {
    dialog.close('autoCreateLines');
    if (firstLineGeneration && !successClose)
      createLineFromScratch(lineToTemplate.product);
    setTimeout(() => {
      setSuccess(false);
      setNumLinesCreated(0);
    }, 500);
  }

  function handleSuccess(numLinesCreated: number) {
    setNumLinesCreated(numLinesCreated);
    setSuccess(true);
  }

  const header = (
    <>
      <img
        className={classes.icon}
        src={'icons/brain.svg'}
        alt="Create Line with AI"
      />
      {!success && (
        <Typography variant="h3">
          Build Lines <i>Faster </i>
          using Artificial Intelligence
        </Typography>
      )}
      {success && (
        <>
          <Typography variant="h3">
            Nice! You used AI to generate
            {` ${numLinesCreated} ${
              numLinesCreated > 1 ? 'Lines' : 'Line'
            }`}{' '}
            and saved {numLinesCreated * 4.5} minutes!
          </Typography>
        </>
      )}
    </>
  );

  const content = (
    <>
      {!success && (
        <Create
          handleSuccess={handleSuccess}
          handleClose={handleClose}
          lineToTemplate={lineToTemplate}
        />
      )}
      {success && <Success handleClose={handleClose} />}
    </>
  );

  return (
    <Dialog
      open={dialog.autoCreateLines}
      title={null}
      content={
        <>
          {header}
          {content}
        </>
      }
    />
  );
}
